<template>
  <!-- Тестовая страница для регистра мпк -->
  <div class="container-page container-page--full-width">
    <div class="earn-apparatus">
      <p class="earn-apparatus__title title-inner">Поручения Загранаппарату</p>

      <div class="earn-apparatus__header-container">
        <div class="earn-apparatus__header-countryBlock">
          <p class="country">Страна</p>
          <SelectMultiComponentCheckbox
            v-model="filter.countryIds"
            :options="computedCountryList"
            placeholder="Выберите страны"
            valueProp="id"
            trackBy="text"
            labelOptions="text"
            checkedOption="id"
          />
        </div>
        <div class="earn-apparatus__header-btnsBlock">
          <ButtonComponent v-permission="permissions.create" mod="gradient-bg" @click="addCard"
            >Создать поручение</ButtonComponent
          >
          <ButtonComponent mod="gradient-bg" @click="goToMonitoring">Мониторинг реализации</ButtonComponent>
          <ButtonComponent mod="gradient-bg" @click="onDownloadBtn" :disabled="exportInProgress"
            >Экспорт</ButtonComponent
          >
        </div>
      </div>
      <div class="mb-4">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>

      <div class="table-container-new earn-apparatus__table-container">
        <TableScrollbar class="table-container-new earn-apparatus__table">
          <table ref="tableElement">
            <colgroup>
              <col class="th-shrink" />
              <col class="th-shrink" />
              <col class="th-common" />
              <col class="th-common" />
              <col class="th-common" />
              <col class="th-date" />
              <col class="th-common" />
              <col class="th-common" />
              <col class="th-common" />
              <col class="th-common" />
              <col class="th-date" />
            </colgroup>
            <thead>
              <tr>
                <th v-if="canEdit || canDelete" class="filter"></th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.CountryName)"
                    @click="changeSorting(SortColumnMap.CountryName)"
                  >
                    Страна
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.TypeName)"
                    @click="changeSorting(SortColumnMap.TypeName)"
                  >
                    Тип поручения
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.AssignmentName)"
                    @click="changeSorting(SortColumnMap.AssignmentName)"
                  >
                    Наименование поручения
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.StatusName)"
                    @click="changeSorting(SortColumnMap.StatusName)"
                  >
                    Статус
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.Deadline)"
                    @click="changeSorting(SortColumnMap.Deadline)"
                  >
                    Срок исполнения
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.ResponsibleEmpolyees)"
                    @click="changeSorting(SortColumnMap.ResponsibleEmpolyees)"
                  >
                    Ответственный
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.Report)"
                    @click="changeSorting(SortColumnMap.Report)"
                  >
                    Отчет
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.EventName)"
                    @click="changeSorting(SortColumnMap.EventName)"
                  >
                    Связанное мероприятие/объект
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.CorrespondentName)"
                    @click="changeSorting(SortColumnMap.CorrespondentName)"
                  >
                    Корреспондент
                  </SortControl>
                </th>
                <th>
                  <SortControl
                    :order="getSortingState(SortColumnMap.ReceiptDate)"
                    @click="changeSorting(SortColumnMap.ReceiptDate)"
                  >
                    Дата поступления
                  </SortControl>
                </th>
              </tr>
              <tr>
                <th v-if="canEdit || canDelete" class="filter"></th>
                <th class="filter"></th>
                <th class="filter">
                  <FilterInput
                    :select2Options="typeList"
                    placeholder="Выберите..."
                    type="select2"
                    v-model="filter.typeId"
                    :select2Settings="select2Settings"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter">
                  <FilterInput
                    placeholder="Введите название..."
                    v-model="filter.name"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter">
                  <FilterInput
                    :select2Options="statusList"
                    placeholder="Выберите..."
                    type="select2"
                    v-model="filter.statusId"
                    :select2Settings="select2Settings"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter nowrap">
                  <div class="date-filter-group">
                    <div class="date-filter-group__item">
                      <FilterInput type="date" v-model="filter.deadlineFrom" @valueChangedDebounced="changeFilter" />
                    </div>
                    <div class="date-filter-group__item">
                      <FilterInput type="date" v-model="filter.deadlineTo" @valueChangedDebounced="changeFilter" />
                    </div>
                  </div>
                </th>
                <th class="filter">
                  <FilterInput
                    type="select2"
                    placeholder="Выберите..."
                    v-model="filter.responsibleEmployeeIds"
                    @valueChangedDebounced="changeFilter"
                    :select2Options="computedResponsiblesList"
                    :select2Settings="select2SettingsMultiple"
                  />
                </th>
                <th class="filter">
                  <FilterInput
                    placeholder="Введите текст..."
                    v-model="filter.report"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
                <th>
                  <FilterInput
                    :select2Options="eventList"
                    placeholder="Выберите..."
                    type="select2"
                    v-model="filter.eventKey"
                    :select2Settings="select2Settings"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
                <th class="filter">
                  <FilterInput
                    type="select2"
                    placeholder="Выберите..."
                    v-model="filter.correspondentIds"
                    @valueChangedDebounced="changeFilter"
                    :select2Options="computedCorrespondentsList"
                    :select2Settings="select2SettingsMultiple"
                  />
                </th>
                <th class="filter">
                  <div class="date-filter-group">
                    <div class="date-filter-group__item">
                      <FilterInput type="date" v-model="filter.receiptDateFrom" @valueChangedDebounced="changeFilter" />
                    </div>
                    <div class="date-filter-group__item">
                      <FilterInput type="date" v-model="filter.receiptDateTo" @valueChangedDebounced="changeFilter" />
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody v-if="page.items?.length">
              <tr v-for="item in page.items" :key="item.id" @dblclick="viewCard(item.id)">
                <td v-if="canEdit || canDelete">
                  <Toolbar
                    v-on="{
                      ...(canEdit ? { edit: () => editCard(item.id) } : {}),
                      ...(canDelete ? { delete: () => deleteCard(item.id) } : {}),
                    }"
                  />
                </td>
                <td>{{ item.countryName }}</td>
                <td>{{ item.type.name }}</td>
                <td>{{ item.assignmentName }}</td>
                <td>
                  <AssignmentStatus :assignment="item" />
                </td>
                <td :class="{ 'deadline-overdue': isDeadlineOverdue(item) }">
                  {{ $momentFormat(item.deadline, 'D MMMM YYYY') }}
                </td>
                <td>
                  <EmployeeList :items="item.responsibleEmployees" />
                </td>
                <td>
                  {{ item.report }}
                </td>
                <td>{{ item.eventName }}</td>
                <td>
                  <EmployeeList v-if="item.correspondent" :items="[item.correspondent]" />
                </td>
                <td>{{ $momentFormat(item.receiptDate, 'D MMMM YYYY') }}</td>
              </tr>
            </tbody>
          </table>
        </TableScrollbar>
      </div>

      <PaginationRedesigned
        v-if="page.pagesTotal > 1"
        :pageCount="page.pagesTotal"
        :currentPage="page.pageNumber"
        @change="onPageChange($event, false)"
        @more="onPageChange($event, true)"
      />

      <!-- modal -->
      <ModalComponent title="Форма создания поручения" @close="closeCard" v-model="dialogState">
        <EapAssignmentCardAdd
          :nn="dialogNn"
          :id="dialogId"
          @save="afterSaveCard"
          @close="closeCard"
          :countryId="card.countryId"
          :projectId="card.projectId"
        />
      </ModalComponent>

      <ModalComponent title="Скачать" @close="downloadDialog = false" v-model="downloadDialog">
        <div>
          <div class="mb-32">
            <div class="mb-4 required">
              <ComponentInput
                v-model="selectedFileFormat"
                type="select2"
                :select2Options="fileFormats"
                :select2Settings="select2SettingsNoClear"
                label="Выберите формат файла"
                required
              />
            </div>
          </div>
          <ButtonComponent mod="gradient-bg" @click="downloadFile" :disabled="exportInProgress"
            >Скачать</ButtonComponent
          >
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import SortControl from '@/common/components/SortControl.vue';
  import Toolbar from '@/common/components/Toolbar.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ModalComponent from '@/components/modals/ModalComponent.vue';
  import TableScrollbar from '@/components/TableScrollbar.vue';

  import API from '../api/assignment';
  import AssignmentStatus from '../components/AssignmentStatus.vue';
  import EapAssignmentCardAdd from '../components/EapAssignmentCardAdd.vue';
  import EmployeeList from '../components/EmployeeList.vue';
  import { SortColumn } from '../utils/constants.js';
  import { isDeadlineOverdue } from '../utils/deadline';

  const PERMISSIONS = {
    view: Constants.Permissions.EapAssignmentAccess,
    create: Constants.Permissions.EapAssignmentCreate,
    edit: Constants.Permissions.EapAssignmentEdit,
    delete: Constants.Permissions.EapAssignmentDelete,
  };

  export default {
    name: 'EapAssignments',

    components: {
      Toolbar,
      SortControl,
      ButtonComponent,
      FilterInput,
      ModalComponent,
      EapAssignmentCardAdd,
      ComponentInput,
      DefaultFilter,
      EmployeeList,
      AssignmentStatus,
      SelectMultiComponentCheckbox,
      PaginationRedesigned,
      TableScrollbar,
    },

    mixins: [security],

    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          countryIds: [],
          name: '',
          deadlineFrom: null,
          deadlineTo: null,
          statusId: null,
          typeId: null,
          eventKey: null,
          urgencyId: null,
          report: '',
          correspondentIds: null,
          responsibleEmployeeIds: null,
          receiptDateFrom: null,
          receiptDateTo: null,
          sortColumn: SortColumn.Deadline,
          sortOrder: Constants.sortOrder.descending,
        },
        page: {},
        canEdit: false,
        canDelete: false,

        select2Settings: Constants.select2Settings,
        select2SettingsMultiple: Constants.select2SettingsMultiple,
        select2SettingsNoClear: {
          language: Constants.langRu,
          allowClear: false,
        },
        countryList: [],
        typeList: [],
        statusList: [],
        urgencyList: [],
        eventList: [],

        dialogState: false,
        dialogNn: 1,
        dialogId: 0,
        exportInProgress: false,

        card: {
          projectId: null,
          countryId: null,
        },

        downloadDialog: false,
        selectedFileFormat: 1,
        fileFormats: [
          { id: 1, text: 'Файл Excel (XLSX)' },
          { id: 2, text: 'Файл Word (DOCX)' },
          { id: 3, text: 'Презентация PowerPoint (PPTX)' },
          { id: 4, text: 'Файл PDF (PDF)' },
        ],

        availableResponsibles: null,
        availableCorrespondents: null,
        tableWidth: 0,
        assignmentIdFromEvent: null,
      };
    },

    computed: {
      permissions() {
        return PERMISSIONS;
      },
      computedCountryList() {
        return [...this.countryList];
      },

      SortColumnMap() {
        return SortColumn;
      },
      // computed для списков Select2 предотвращают блокировку скролла
      computedCorrespondentsList() {
        return this.mapPersons(this.availableCorrespondents);
      },
      computedResponsiblesList() {
        return this.mapPersons(this.availableResponsibles);
      },
    },

    async mounted() {
      this.calculateTableWidth();
      window.addEventListener('resize', this.calculateTableWidth);
      if (this.assignmentIdFromEvent) {
        this.$nextTick(() => {
          this.editCard(this.assignmentIdFromEvent);
          this.assignmentIdFromEvent = 0;
        });
      }
    },

    beforeUnmount() {
      window.removeEventListener('resize', this.calculateTableWidth);
    },

    async created() {
      if (this.$route.query && this.$route.query.assignmentIdFromEvent) {
        this.assignmentIdFromEvent = Number(this.$route.query.assignmentIdFromEvent);
      }

      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.checkPermission(PERMISSIONS.delete).then((response) => {
        this.canDelete = response.data;
      });

      Promise.all([loadFilter(this.$options.name), this.getUrlFilters()]).then(([savedFilter, urlFilters]) => {
        let filter;

        if (urlFilters && Object.keys(urlFilters).length > 0) {
          filter = { ...this.defaultFilter(), ...urlFilters };
        } else if (savedFilter) {
          filter = savedFilter;
        } else {
          filter = this.defaultFilter();
        }

        this.filter = filter;
        saveFilter(this.$options.name, this.filter);

        Utils.loadSelectOptions('countryList', this.countryList);
        Utils.loadSelectOptions('eapAssignmentTypeList', this.typeList);
        Utils.loadSelectOptions('eapAssignmentStatusList', this.statusList);
        Utils.loadSelectOptions('eapAssignmentUrgencyList', this.urgencyList);
        this.loadPage(false);
        this.loadEvents();
        this.fetchResponsibles();
        this.fetchCorrespondents();
      });

      if (!this.assignmentIdFromEvent) {
        this.$router.replace({
          name: 'EapAssignments',
        });
      }
    },

    methods: {
      defaultFilter() {
        return {
          countryIds: [],
          name: '',
          deadlineFrom: null,
          deadlineTo: null,
          statusId: null,
          typeId: null,
          eventKey: null,
          urgencyId: null,
          report: '',
          correspondentIds: null,
          responsibleEmployeeIds: null,
          receiptDateFrom: null,
          receiptDateTo: null,
          sortColumn: SortColumn.Deadline,
          sortOrder: Constants.sortOrder.descending,
        };
      },

      loadEvents() {
        API.getEventForList().then((response) => {
          this.eventList = [{ id: '', text: Constants.emptySelectOptionText, selected: true }];
          if (response.data && response.data.length) {
            response.data.forEach((i) => this.eventList.push({ id: i.eventId + ';' + i.eventType, text: i.eventName }));
          }
        });
      },
      goToMonitoring() {
        this.$router.push({
          name: 'EapAssignmentMonitoring',
          query: { countryIds: this.filter.countryIds },
        });
      },
      addCard() {
        this.dialogState = true;
        this.dialogNn++;
        this.dialogId = 0;
      },
      editCard(id) {
        this.dialogState = true;
        this.dialogNn++;
        this.dialogId = id;
      },
      viewCard(id) {
        this.$router.push({ name: 'EapAssignmentCard', params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id)
              .then((response) => {
                console.log(response);
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      afterSaveCard() {
        this.dialogState = false;
        this.resetCard();
        this.loadPage(false);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      loadPage(addToExist) {
        var params = Object.assign(this.filter, this.request);
        API.search(params).then((response) => {
          if (!addToExist) {
            this.page = {};
            this.$nextTick(() => {
              this.page = response.data;
              this.$nextTick(() => {
                this.calculateTableWidth();
              });
            });
          } else if (response.data) {
            //добавляем к существующему
            this.page.pageNumber = response.data.pageNumber;
            this.page.items = this.page.items.concat(response.data.items);
          }
        });

        if (this.$route.params.projectId && this.$route.params.countryId) {
          this.card.projectId = this.$route.params.projectId;
          this.card.countryId = this.$route.params.countryId;
          this.addCard();
        }
      },
      resetCard() {
        this.card = {
          projectId: null,
          countryId: null,
        };
      },
      closeCard() {
        this.dialogState = false;
        this.resetCard();
      },
      changeSorting(id) {
        if (this.filter.sortColumn == id) this.filter.sortOrder = this.filter.sortOrder == 0 ? 1 : 0;
        else this.filter.sortOrder = 0;
        this.filter.sortColumn = id;
        this.loadPage(false);
      },
      getSortingState(columnId) {
        if (this.filter.sortColumn !== columnId) {
          return null;
        }
        return ['ascending', 'descending'][this.filter.sortOrder] ?? null;
      },
      onDownloadBtn() {
        this.selectedFileFormat = 1;
        this.downloadDialog = true;
      },
      downloadFile() {
        this.exportInProgress = true;
        const params = Object.assign({ formatId: this.selectedFileFormat }, this.filter);
        API.export(params)
          .then(() => {
            this.downloadDialog = false;
            this.exportInProgress = false;
          })
          .catch(() => {
            Constants.alert.fire('Скачивание файла', 'Не удалось сформировать отчет', 'error');
            this.downloadDialog = false;
            this.exportInProgress = false;
          });
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      async fetchResponsibles() {
        this.availableResponsibles = await API.getResponsibleCandidates({
          countryIds: this.filter.countryIds,
        }).then((response) => response?.data);
      },
      async fetchCorrespondents() {
        this.availableCorrespondents = await API.getCorrespondentsCandidates({
          countryIds: this.filter.countryIds,
        }).then((response) => response?.data);
      },
      mapPersons(list) {
        return list?.map?.((person) => ({
          id: person.id,
          text: person.fullName,
        }));
      },
      isDeadlineOverdue(item) {
        return isDeadlineOverdue(item);
      },
      calculateTableWidth() {
        if (this.$refs.tableElement) {
          this.tableWidth = this.$refs.tableElement.scrollWidth;
        }
      },
      getUrlFilters() {
        const query = this.$route.query;
        const filters = {};

        if (query.countryIds) {
          filters.countryIds = Array.isArray(query.countryIds)
            ? query.countryIds.map((id) => parseInt(id))
            : [parseInt(query.countryIds)];
        }

        if (query.createdFrom) {
          filters.receiptDateFrom = query.createdFrom;
        }

        if (query.createdTo) {
          filters.receiptDateTo = query.createdTo;
        }

        return filters;
      },
    },

    watch: {
      'filter.countryIds'() {
        this.fetchResponsibles();
        this.fetchCorrespondents();
        this.changeFilter();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .earn-apparatus {
    &__title {
      margin-bottom: 24px;

      @media (max-width: $laptop) {
        margin-bottom: 16px;
      }
    }
    &__header {
      &-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 24px;
        margin-bottom: 40px;

        @media (max-width: $laptop) {
          margin-bottom: 24px;
        }
      }
      &-countryBlock {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
        max-width: 360px;
        width: 100%;

        .country {
          font: $fira-16;
        }

        .multiselect {
          flex: 1 1 0%;
        }

        @media (max-width: $mobile) {
          max-width: 100%;

          .multiselect {
            flex-basis: 100%;
          }
        }
      }
      &-btnsBlock {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        gap: 8px;

        @media (max-width: $mobile) {
          flex: 1 1 0%;
          grid-auto-flow: row;
        }
      }
    }
    &__table-container {
      padding: 0 80px;
      width: 100vw;
      margin-left: calc(-50vw + 50%);
    }
    &__table {
      table {
        thead {
          th {
            position: relative;
            vertical-align: bottom;
            font: $fira-16-M;
            color: $dark-grey-1;
            padding: 16px 20px 20px;
            border-bottom: 2px solid $green;
            &:nth-of-type(5) {
              text-align: center;
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid $light-grey-5;
            cursor: pointer;
            transition: color 0.15s ease;

            &:hover {
              color: $blue;

              td {
                color: $blue;
              }
            }
          }
          td {
            padding: 20px;
            vertical-align: top;
            font: $fira-14;
            p {
              margin-bottom: 0px;
            }

            &.deadline-overdue {
              color: red;
            }
          }
          button {
            margin-top: 12px;
          }
        }
      }
      &-footer {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 18px;
        p {
          font-size: 12px;
          line-height: 18px;
          color: $green;
          border-bottom: 1px dashed $green;
          margin-bottom: 0px;
        }
      }
    }
  }

  .scroll-container {
    overflow-x: auto;
    overflow-y: hidden;
    height: 17px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-bottom: none;

    &.top-scroll-container {
      margin-bottom: 0;
      border-radius: 4px 4px 0 0;
    }

    .scroll-content {
      height: 1px;
    }

    &::-webkit-scrollbar {
      height: 12px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
      &:hover {
        background: #a8a8a8;
      }
    }
  }

  .date-filter-group {
    display: flex;
    align-items: center;
    gap: 8px;

    & :deep(.v3dp__input_wrapper input) {
      min-height: calc(1.25rem + 10px) !important;
      font: $fira-14;
    }
  }

  .date-filter-group__item {
    flex: 0 1 auto;
    min-width: 84px;
  }

  .filter {
    :deep(.input-group-wrapper input:not([type='checkbox']):not([type='time'])) {
      padding: 0 8px;
    }
  }

  .th-shrink {
    width: 0;
  }
  .th-common {
    min-width: 204px;
  }
  .th-date {
    min-width: 280px;
  }

  .table-container-new {
    overflow-x: scroll !important;
    scrollbar-width: none;
  }
</style>
